module.exports = __webpack_public_path__ + "img/08univha.b847f470.png";